import * as yup from "yup";
import { FormField } from "./enum";

export const getValidationSchema = (t: (value: string) => string) =>
  yup.object().shape({
    [FormField.BIO]: yup.string(),
  });
